module.exports = __webpack_public_path__ + "img/sr.183a9e40.svg";